import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { resolvePaletteRoleForegroundToken } from "../../../functions/resolvePaletteRoleForegroundToken";
import Typography from "../../typography/Typography";
import { ReactComponent as BCALogo } from "./BCA Logo.svg";
import { StyledAnchor } from "./Logo.styles";
import { LogoProps } from "./Logo.types";

const Logo: React.FC<LogoProps> = ({
	colorOn = "bg_dark",
	href = "/",
	className,
	title,
	...props
}) => {
	const block = new BemIt("Logo");
	const titleColor = resolvePaletteRoleForegroundToken(colorOn);

	return (
		<StyledAnchor
			className={addClass(className).after(block)}
			href={href}
			{...props}
		>
			<BCALogo viewBox="0 0 206 70" width="71px" height="24px" />
			<Typography color={titleColor} variant="body-large">
				{title}
			</Typography>
		</StyledAnchor>
	);
};

export default Logo;
